import g from '@/model/language'
import { IsRights, Modulel, Permission, Clone, ToComponentData, ToSubmitEntity, CheckByConfig, ToSubmitData, CheckByEntity, toSelect } from '@/config/config'
import { userRequest as UserRequest } from '@/request/user'
import { RegionRequest } from '@/request/Region'
import '@/lf'

export function InitUserPage(StoreName, GNFunc) {
    var dc = { data: {} };

    var defaultStoreName = 'UserPage'
    if (StoreName) {
        defaultStoreName = StoreName;
    }

    var GN = function (storeName) {
        return defaultStoreName + '$' + storeName;
    }

    if (GNFunc) {
        GN = GNFunc;
    }

    defaultStoreName = GN('UserPage')
    var vueObj = window.rootVue;
    var vueState = vueObj.$store.state;
    var state = vueObj.$store.state[defaultStoreName];

    var UserPage = {
        Title: g('$注册'),
        storeName: defaultStoreName,
        GN: GN,
        AddModuleShow: false,
        AddModalName: g('$注册'),
        IsInit: false,
        Search: //page-search-table 配置
            [

            ],
        Table: {

        },
        FieldData: [

            { nickName: g('$登录名'), field: 'LoginName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${登录名}为必填') }, initValue: '' },
            { nickName: g('$姓'), field: 'FirstName',  type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${姓}为必填') }, initValue: '' },
            { nickName: g('$国家'), field: 'Country', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${国家}为必填") } , forSelectStoreName: GN('OrderCountry')},
            { nickName: g('$名'), field: 'LastName',  type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${名}为必填') }, initValue: '' },
            { nickName: g('$密码'), field: 'Password', type: 'Password', error: '', isRequired: true, j: { rex: 'w', tips: g('${密码}为必填') }, initValue: '', IsShowCheck: function (entity, field) { return !entity.ID; } },
            { nickName: g('$确认密码'), field: 'RPassword', type: 'Password', error: '', isRequired: true, j: { rex: 'w', tips: g('${确认密码}为必填') }, initValue: '', IsShowCheck: function (entity, field) { return !entity.ID; } },
            { nickName: g('$邮箱'), field: 'Email', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${Email}为必填') }, initValue: '' },
            {
                nickName: g('$联系软件'), field: 'contactType', type: 'Select',  j: { rex: 'w', tips: g('${WeChat/Skype}为必填') }, error: '', initValue: 'WeChat',  forSelectStoreName: 'contactType',
                initField(vueObj, callback, data, field) {
    
    
                    },
                    OnChange (d){
                        vueObj.$store.state['name'].name= d
                   
                    }
                },
            { nickName: '', field: 'contactID', type: 'String', error: '',  j: { rex: 'w', tips: g('${WeChat ID/Skype ID}为必填') }, initValue: '' },
            {
            nickName: g('$币种'), field: 'CurrencyID', type: 'Select', isRequired: true, j: { rex: 'w', tips: g('${币种}为必填') }, error: '', forSelectStoreName: GN('UserCurrencyID'),
            initField(vueObj, callback, data, field) {


                }
            },

          { nickName: g('$服务类型'), field: 'ServiceType', type: 'Select', error: '', isRequired: true, j: { rex: 'w', tips: g('${服务类型}为必填') }, initValue: '', forSelectStoreName: 'ServeLevels' },

            {
              nickName: g('$客户等级'),
              field: 'CusLevel',
              type: 'Select',
              forSelectStoreName: 'UserLevels',
              isRequired: true, j: {
                rex: 'w',
                tips: g('${客户等级}为必填')
              },
            },

            {
                nickName: g('$客户来源'),
                field: 'Customer.Source',
                type: 'Select',
                initValue: '',
                forSelectStoreName: 'SourceList',
                AddString(d) {
                    return toSelect(d.Customer.Source, 'SourceList')
                },
                 isRequired: true, j: {
                    rex: 'w',
                    tips: g('${客户来源}为必填')
                  },
            },
         
            { nickName: g('$手机'), field: 'PhoneNumber', type: 'String', error: '', initValue: ' ' },
            { nickName: g('$留言'), field: 'AuditNotes', type: 'Textarea', error: '', initValue: '' },
//
        ],
        FieldData4: [
            {
                nickName: g('$联系软件'), field: 'contactType', type: 'Select',  j: { rex: 'w', tips: g('${WeChat/Skype}为必填') }, error: '', initValue: 'WeChat',  forSelectStoreName: 'contactType',
                initField(vueObj, callback, data, field) {
    
    
                    },
                    OnChange (d){
                        vueObj.$store.state['name'].name= d
                   
                    }
                },
            { nickName: '', field: 'contactID', type: 'String', error: '',  j: { rex: 'w', tips: g('${WeChat ID/Skype ID}为必填') }, initValue: '' },
            {
            nickName: g('$币种'), field: 'CurrencyID', type: 'Select', isRequired: true, j: { rex: 'w', tips: g('${币种}为必填') }, error: '', forSelectStoreName: GN('UserCurrencyID'),
            initField(vueObj, callback, data, field) {


                }
            },

          { nickName: g('$服务类型'), field: 'Gender', type: 'Select', error: '', isRequired: true, j: { rex: 'w', tips: g('${服务类型}为必填') }, initValue: '', forSelectStoreName: 'ServeLevels' },

            {
              nickName: g('$客户等级'),
              field: 'CusLevel',
              type: 'Select',
              forSelectStoreName: 'UserLevels',
              isRequired: true, j: {
                rex: 'w',
                tips: g('${客户等级}为必填')
              },
            },
            {
                nickName: g('$客户来源'),
                field: 'Customer.Source',
                type: 'AddString',
                initValue: '',
                forSelectStoreName: 'SourceList',
                AddString(d) {
                    return toSelect(d.Customer.Source, 'SourceList')
                },
                 isRequired: true, j: {
                    rex: 'w',
                    tips: g('${客户来源}为必填')
                  },
            },

            // { nickName: g('$性别'), field: 'Gender', type: 'Select', error: '', isRequired: true, j: { rex: 'w', tips: g('${性别}为必填') }, initValue: '', forSelectStoreName: 'UserGender' },
            // { nickName: g('$生日'), field: 'Birthday', type: 'DateTime', error: '', j: { rex: 'w', tips: g('${生日}为必填') }, initValue: '' },
            { nickName: g('$手机'), field: 'PhoneNumber', type: 'String', error: '', initValue: ' ' },
            { nickName: g('$留言'), field: 'AuditNotes', type: 'Textarea', error: '', initValue: '' },
//
        ],

        FieldData2: [

            { nickName: g('$客户编码'), field: 'CusCode', type: 'String', error: '', IsNotEdit: true },
            { nickName: g('$识别码'), field: 'CompanyCode', type: 'String', error: '' },
            { nickName: g('$公司名称'), field: 'Name', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${公司名称}为必填") } },
            { nickName: g('$国家'), field: 'Country', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${国家}为必填") } },
            { nickName: g('$省份'), field: 'Provine', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${省份}为必填") } },
            { nickName: g('$城市'), field: 'City', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${城市}为必填") } },
            { nickName: g('$公司地址'), field: 'AddressLine', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${公司地址}为必填") } },
            { nickName: g('$业务员(客户经理)'), field: 'SalesUserID', type: 'Select', error: '', forSelectStoreName: GN('UserSalesUserID') },
            { nickName: g('$证件号'), field: 'CertificateNo', type: 'String', error: '' },
            { nickName: g('$企业性质'), field: 'EnterpriseNature', type: 'Textarea', error: '' },
            { nickName: g('$认证电话'), field: 'AuthenticationPhone', type: 'String', error: '' },
            { nickName: g('$认证文件'), field: 'AuthenticatedDocument', type: 'UploadFile',UploadRID:'UserManage', error: '', buttonName: g("$点击上传"), class: "max300", error: '' },

            { nickName: g('$改变状态时间'), field: 'ChangeStateTime', type: 'DateTime', error: '', IsNotEdit: true },
            { nickName: g('$Email'), field: 'Email', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${Email}为必填") } },
            { nickName: g('$认证状态'), field: 'Autherized', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${认证状态}为必填") }, forSelectStoreName: ('UserAutherized') },

            {
                nickName: g('$审核备注'), field: 'AuditNotes', type: 'Textarea', error: '', IsNotEdit: true,
                initField(vueObj, callback, data, field) {
                    if (data.Status == 3) {
                        field.IsNotEdit = false;
                    }else{
                        field.IsNotEdit = true;
                    }
                }
            },

        ],

        FieldData3: [
            {
                nickName: g('$结算方式'), field: 'PaymentsType', type: 'Select', error: '', forSelectStoreName: ('OrganizationSettlementMethod'),
                initField(vueObj, callback, data, field) {
                    if (!data.ID || data.ID == "0") {
                        field.IsNotEdit = false;
                    }else{
                        field.IsNotEdit = true;
                    }
                }
            },
            {
                nickName: g('$信用额度'), field: 'Credit', type: 'String', error: '',
                initField(vueObj, callback, data, field) {
                    if (!data.ID || data.ID == "0") {
                        field.IsNotEdit = false;
                    }else{
                        field.IsNotEdit = true;
                    }
                }
            },
            {
                nickName: g('$已用额度'), field: 'CreditUse', type: 'String', error: '', IsNotEdit: true,
                initField(vueObj, callback, data, field) {
                    if (!data.ID && data.ID != "0") {
                        field.IsNotEdit = true;
                    }
                }
            },
            {
                nickName: g('$现金余额'), field: 'Balance', type: 'String', error: '', IsNotEdit: true,
                initField(vueObj, callback, data, field) {
                    if (!data.ID || data.ID == "0") {
                        field.IsNotEdit = false;
                    }else{
                        field.IsNotEdit = true;
                    }
                }

            },
            {
                nickName: g('$保证金'), field: 'Guarantee', type: 'String', error: '', IsNotEdit: true,
                initField(vueObj, callback, data, field) {

                }
            },
            {
                nickName: g('$币种'), field: 'CurrencyID', type: 'Select', error: '', forSelectStoreName: GN('UserCurrencyID') ,
                initField(vueObj, callback, data, field) {
                    if (!data.ID || data.ID == "0") {
                        field.IsNotEdit = false;
                    }else{
                        field.IsNotEdit = true;
                    }

                }
            }
        ],

        initPageData() {
            vueObj = window.rootVue;

            var vueState = vueObj.$store.state;
            state = vueObj.$store.state[defaultStoreName];
            var store = state

            if (!store) {
                store = Clone(UserPage);
                store.Entity = ToSubmitData(ToComponentData(UserPage.FieldData))
                store.SearchEntity = ToSubmitData(ToComponentData(UserPage.Search))
                store.IsInit = true;
                vueObj.$set(vueObj.$store.state, UserPage.storeName, store)
            }

            state = store;
            return store
        },
        SearchPageData(callback) {

        },

        GetData(ID, callback) {

        },

        initPublicDataCurrencyID(callback) {

            PublicDataRequest.GetPublicDataByType(function (d) {
                for (var i of d) {
                    i.Value = parseInt(i.Value)
                }
                vueObj.$set(vueObj.$store.state, GN("UserCurrencyID"), d)
                if (callback) { callback(d) }
            }, 6)

        },
        initRegionCountry(callback) {
            
                        RegionRequest.SearchRegion(function (d) {
                           var arr = [];
                            for (var i of d.Records) {
                                i.Text = i.EnName + "-" + i.CnName;
                                 i.Value = i.ID;
                                //i.Value =i.EnName + "-" + i.CnName;
                                arr.push(i)
                            }
            
                            vueObj.$set(vueObj.$store.state, GN("OrderCountry"), arr)
                            if (callback) { callback(d) }
                        }, {
                                PageSize: 10000,
                            })
                    },         
        SetUserAutherized: function (UserID, Autherized, AuditNotes, callback) {

            UserRequest.SetUserAutherized(function (d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, UserID, Autherized, AuditNotes)

        },


        Update: function (store, callback) {
            if(store.Entity.contactType=="WeChat"){
                store.Entity.contactType=1
            }else{
                store.Entity.contactType=2
            }
          store.Entity.Account = { PaymentsType: 0, CurrencyID: store.Entity.CurrencyID}
            store.Entity.Customer = {
              CustomerType: 1,
              Name: " ",
              CusLevel: store.Entity.CusLevel,
             
              Provine: " ",
              ReferrerCode: "",
              City: " ",
              AddressLine: " ",
              Email: store.Entity.Email,
              Autherized: 1,
              AuditNotes: store.Entity.AuditNotes,
              contactType:store.Entity.contactType,
              ServiceType:store.Entity.ServiceType,
              contactID:store.Entity.contactID,
              Country:store.Entity.Country
            }

            if (window.$.cookie("TG")) {
                store.Entity.Customer.ReferrerCode = window.$.cookie("TG");
            }

                var entity = ToSubmitEntity(store.Entity, store.FieldData);
                console.log(store.Entity,store.FieldData,"国家")
                entity.UserType = 1;
                if (CheckByEntity(entity, store.FieldData)) {
                    UserRequest.Register(function (d) {
                        if (d.Message == "OK") {
                            if (callback) { callback(d) }
                        } else {
                            vueObj.$message.error(d.Message)
                        }
                    }, entity)
                }

        }
    }

    return UserPage;
}
import { PublicDataRequest } from '@/request/PublicData'







// WEBPACK FOOTER //
// ./src/config/Sys/RegisterConfig.js